import Vue from "vue";
import Vuetify from "vuetify/lib";

// 引入本地 Roboto 字体
import 'typeface-roboto/index.css'

// 引入本地 MDI 样式（npm 安装后 node_modules 路径）
import "@mdi/font/css/materialdesignicons.min.css";

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: "mdi", // 指定使用 mdi 图标库
  },
};

export default new Vuetify(opts);
